const escapedChars = /[\u00A0-\u9999<>&]/g;

/**
 * Replaces weird UTF characters with HTML entitites. Useful for escaping user input. Based on:
 * https://stackoverflow.com/questions/18749591/encode-html-entities-in-javascript
 */
export const htmlEscape = (value: string): string =>
  value.replace(escapedChars, c => `&#${c.charCodeAt(0)};`);
